import { Navigate, useLocation } from "react-router-dom";
import {
  LandingPageFactory,
  LandingPageType,
} from "../components/LandingPageFactory";
import { useLandingPageConfig } from "../hooks/useLandingPageConfig";
import { useScrollToTop } from "../hooks/useScrollManagement";

const ROUTE_TO_PAGE_TYPE: Record<string, LandingPageType> = {
  contact: "contact",
  personal: "personal",
  verify: "verification",
  redirect: "redirect",
  "no-sites": "no-sites-available",
  "qualified-redirect": "qualified-redirect",
  "direct-redirect": "direct-redirect",
  "thank-you": "thank-you",
  "emr-consent": "emr-consent",
};

export default function LandingPage() {
  const location = useLocation();
  const pageConfig = useLandingPageConfig();

  useScrollToTop([location.pathname]);

  // Redirect if no valid config was found OR if the page is inactive.
  // Inactive pages go to their configured inactiveRedirectPath (if any), otherwise home.
  if (!pageConfig || pageConfig.status === "inactive") {
    const target = pageConfig?.inactiveRedirectPath ?? "/";
    return <Navigate to={`${target}${location.search}`} replace />;
  }

  const pathSegment = location.pathname.split("/").filter(Boolean).pop() || "";
  const pageType = ROUTE_TO_PAGE_TYPE[pathSegment] || "standard";

  return (
    <LandingPageFactory
      pageConfig={pageConfig}
      pageType={pageType}
      data-testid={`landing-page-${pageType}`}
    />
  );
}
